document.addEventListener('alpine:init', () => {
  const syncRechargeCartWithTheme = () => {
    const rechargeCartDrawer = document.getElementById('recharge-storefront-experiences__cart-drawer');

    if (!rechargeCartDrawer) {
      return;
    }

    const checkRechargeCartState = () => {
      if (!rechargeCartDrawer.shadowRoot) {
        return;
      }

      const cartDialog = rechargeCartDrawer.shadowRoot.querySelector('[role="dialog"]');
      const overlay = rechargeCartDrawer.shadowRoot.querySelector('[data-state]');

      if (!cartDialog && !overlay) {
        return;
      }

      const isOpen = overlay?.getAttribute('data-state') === 'open' ||
                     cartDialog?.getAttribute('data-state') === 'open';

      if (Alpine.store('xMiniCart')) {
        if (!isOpen && Alpine.store('xMiniCart').open) {
          Alpine.store('xMiniCart').hideCart();
        } else if (isOpen && !Alpine.store('xMiniCart').open) {
          Alpine.store('xMiniCart').open = true;
          Alpine.store('xPopup').open = true;
        }
      }
    };

    const observeShadowRoot = () => {
      if (!rechargeCartDrawer.shadowRoot) {
        setTimeout(observeShadowRoot, 100);
        return;
      }

      const observer = new MutationObserver((mutations) => {
        checkRechargeCartState();
      });

      observer.observe(rechargeCartDrawer.shadowRoot, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-state', 'aria-hidden']
      });

      checkRechargeCartState();
    };

    observeShadowRoot();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncRechargeCartWithTheme);
  } else {
    setTimeout(syncRechargeCartWithTheme, 500);
  }
});
